"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PluggableElementBase2 = _interopRequireDefault(require("./PluggableElementBase"));

var _mstReflection = require("../util/mst-reflection");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TrackType = /*#__PURE__*/function (_PluggableElementBase) {
  (0, _inherits2.default)(TrackType, _PluggableElementBase);

  var _super = _createSuper(TrackType);

  function TrackType(stuff) {
    var _this;

    (0, _classCallCheck2.default)(this, TrackType);
    _this = _super.call(this, stuff);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "stateModel", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "configSchema", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "displayTypes", []);
    _this.stateModel = stuff.stateModel;
    _this.configSchema = stuff.configSchema;

    if (!_this.stateModel) {
      throw new Error("no stateModel defined for track ".concat(_this.name));
    }

    if (!_this.configSchema) {
      throw new Error("no configSchema provided for track ".concat(_this.name));
    }

    if (!(0, _mstReflection.getDefaultValue)(_this.configSchema).type) {
      var name = _this.configSchema ? _this.configSchema.name : 'UNKNOWN';
      throw new Error("".concat(name, " is not explicitlyTyped"));
    }

    return _this;
  }

  (0, _createClass2.default)(TrackType, [{
    key: "addDisplayType",
    value: function addDisplayType(display) {
      this.displayTypes.push(display);
    }
  }]);
  return TrackType;
}(_PluggableElementBase2.default);

exports.default = TrackType;